import store from '../store'

import { updateFileUploadProgress } from '../modules/actions/files'

// itemIdToUpdate can be provided manually, e.g. this is used for approving internal ads
export function updateItem(items, updatedItem, itemIdToUpdate) {
  return items.map(item => {
    if (String(item.id) === String(itemIdToUpdate || updatedItem.id)) {
      return {
        ...item,
        ...updatedItem
      }
    }
    return item
  })
}

export function deleteItemById(items, itemId) {
  return items.filter(item => String(item.id) !== String(itemId))
}

export function deleteItemsByPropertyName(items, itemsToDelete, propertyName) {
  return items.filter(item => !itemsToDelete.includes(item[propertyName]))
}

export function simulateFileUploadProgress(fileName, intervalUpdate = 900) {
  const { files } = store.getState()

  const { [fileName]: currentFileUploadProgress } = files.fileUploadProgress
  let fileUploadProgress = currentFileUploadProgress

  return setInterval(() => {
    // as it's not possible to predict or calculate current porcessing progress
    // simulate progress with updating it every intervalUpdate until it reach 99
    if (fileUploadProgress < 99) {
      fileUploadProgress += 1

      store.dispatch(updateFileUploadProgress({ [fileName]: fileUploadProgress }))
    }
  }, intervalUpdate)
}
